<div style="height:fit-content;">
  <div style="margin:20px;">
    <span style="display:inline;">
      @for (action of actionTable; track action) {
        <button [ngClass]="action.actionClass" class="ps-table-action-link"
          (click)="action.action(params.data);">
          @if (action.iconClass) {
            <i [ngClass]="action.iconClass"></i>
          }
          {{action.name}}
        </button>
      }
    </span>
  </div>
</div>
